class FeaturedProductList extends HTMLElement {
  constructor() {
    super();
    const { slides_per_view, id, slides_per_view_mobile } = $(this).data();
    this.class = 'swiper-' + id;
    this.slides_per_view = slides_per_view; // 一页展示多少个
    this.slides_per_view_mobile = slides_per_view_mobile; // 移动端一页展示多少个
    this.init();
  }
  init() {
    const nextEl = $(this).find('.button-next');
    const prevEl = $(this).find('.button-prev');
    this.swiper = new Swiper(`.${this.class}`, {
      spaceBetween: 10,
      slidesPerView: this.slides_per_view_mobile,
      //   navigation: {
      //     nextEl: nextEl,
      //     prevEl: prevEl,
      //   },
      breakpoints: {
        769: {
          slidesPerView: this.slides_per_view,
          spaceBetween: 8
        }
      }
    });
    nextEl.on('click', () => {
      this.swiper.slideNext();
    });
    prevEl.on('click', () => {
      this.swiper.slidePrev();
    });
  }
}

$(document).ready(function () {
  customElements.define('featured-product-list', FeaturedProductList);
});
